import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Home } from './pages/Home';
import { Faqs } from './pages/Faqs';
import { NotFound } from './pages/NotFound';
import { ScrollToTop } from './components/ScrollToTop';
import './App.css';

const Layout = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <main className="flex-grow">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq/" element={<Faqs />} />
          <Route path="/faqs" element={<Navigate to="/faq/" replace />} />
          <Route path="/faqs/" element={<Navigate to="/faq/" replace />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
    </div>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Layout />
    </Router>
  );
}

export default App;
